<template>
  <div class="w-full flex flex-row mt-3 px-6">
    <div class="slider-cont w-full">
      <div class="slider-wrapper relative">
        <VueSlickCarousel
          ref="mapSlider"
          v-bind="settings"
          @beforeChange="beforeChangeCarousel"
        >
          <div
            class="map-slide"
            v-for="(mapSlide, mapIndex) in mapData"
            :key="mapIndex"
          >
            <div class="flex flex-col">
              <div
                :class="typeClass"
                class="map-type-wrapper relative overflow-hidden h-12 float-left"
              >
                <span
                  class="map-type absolute inset-0 m-auto w-full text-very-light-gray text-2 uppercase text-center z-10 flex items-center justify-center"
                  v-html="mapSlide.type"
                ></span>
                <div
                  :class="typeClass2"
                  class="absolute h-12 inset-0 m-auto bg-vivid-pink"
                ></div>
              </div>
              <h1
                class="font-rakkas 3sm:text-8.4xl xs:text-5 leading-5.2 text-white 3sm:mt-10 xs:mt-2"
                v-html="mapSlide.name"
              ></h1>
              <div class="mt-14">
                <img
                  class="w-full"
                  :src="`${imgPath}/Section04/${mapSlide.imgUrl}`"
                />
              </div>
              <div class="w-full flex flex-row justify-between mt-8">
                <button
                  :class="btn.isActive ? 'border-vivid-pink' : 'border-black'"
                  class="3sm:w-5/12 xs:w-6/12 3sm:h-24 xs:h-16 bg-very-dark-blue text-white font-mulish-extra-bold tracking-wider 3sm:text-2.5 xs:text-2.4 xs:first:mr-4 rounded-xl border-2 shadow-map-btn outline-none"
                  v-for="(btn, btnIndex) in mapSlide.desc"
                  :key="btnIndex"
                  v-html="`PART ${btnIndex + 1}`"
                  @click="handlePart(mapIndex, btnIndex)"
                ></button>
              </div>
              <div class="w-full mt-8">
                <div
                  v-for="(desc, descIndex) in mapSlide.desc"
                  :key="descIndex"
                >
                  <div v-if="desc.isActive" class="flex flex-col">
                    <span
                      v-html="desc.title"
                      class="font-mulish-bold text-very-pale-violet 3sm:text-2.2 xs:text-1.8"
                    ></span>
                    <p
                      v-html="desc.text"
                      class="mt-8 font-mulish-regular text-very-light-gray 3sm:text-1.8 xs:text-1.2 tracking-wider 3sm:leading-2.2 xs:leading-1.6"
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      typeClass: 'w-139',
      typeClass2: 'w-12',
      settings: {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  methods: {
    handlePart: function(mapIndex, descIndex) {
      console.log(mapIndex, descIndex);
      for (let i = 0; i < this.mapData[mapIndex].desc.length; i++) {
        console.log('handlePartDesc');
        if (descIndex === i) {
          this.mapData[mapIndex].desc[i].isActive = true;
        } else {
          this.mapData[mapIndex].desc[i].isActive = false;
        }
      }
    },
    beforeChangeCarousel: function(oldIndex, newIndex) {
      console.log(newIndex);
      if (newIndex === 0) {
        this.typeClass = 'w-139';
        this.typeClass2 = 'w-11';
      }
      if (newIndex === 1) {
        this.typeClass = 'w-139';
        this.typeClass2 = 'w-11';
      }
      if (newIndex === 2) {
        this.typeClass = 'w-316';
        this.typeClass2 = 'w-138';
      }
      if (newIndex === 3) {
        this.typeClass = 'w-316';
        this.typeClass2 = 'w-138';
      }
    },
  },
  computed: {
    ...mapState({
      mapData: state => state.MapSection.mapData,
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.map-type-wrapper:before {
  content: '';
  position: absolute;
  top: -15px;
  left: 0px;
  border-top: 30px solid transparent;
  border-right: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
.map-type-wrapper:after {
  content: '';
  position: absolute;
  top: -15px;
  right: 0px;
  border-top: 30px solid transparent;
  border-left: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
</style>
